import React from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";
import _ from 'underscore';
import FileUpload from "./FileUpload";
import { MDBBtn, MDBBtnGroup, MDBIcon } from "mdbreact";
import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import StarRatings from 'react-star-ratings';
import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";
import ReactQuill from "react-quill";
import Listings from './Listings';
let context = null;

class FormItem extends React.Component {



  constructor(props) {
    super();
    this.state = {
      model: [],
      items: {},
      linkedList: [],
      linkedList1: [],
      linkedList2: [],
      linkedList3: [],
      linkedList4: [],
      linkedList5: [],
      linkedList6: [],
      linkedList7: [],
      id: "",
      selectedFile: null, fileUrl: "", deleteModal: false, msg: ""
    };
    context = this;
  }


  componentDidMount() {

    let model = this.props.model;
    let firebaseDb = this.props.firebaseLinkedList;
    

    model = _.filter(model, function (item) {

      return item.type != "ACTIONS";
    });


    this.setState({ model: model });

    if (firebaseDb != undefined && Array.isArray(firebaseDb)) {
      // this.getListFromDb(firebaseDb);

        _.each(firebaseDb,function(db,key){


          if(key==0){
            key = '';
          }
          context.getListFromDb(db,key);

        });

    }
    else if (firebaseDb != undefined) {
      this.getListFromDb(firebaseDb,'');

    }



  }

  componentWillReceiveProps(newProps) {
    if (newProps.item != this.props.item) {
      let items = newProps.item;
      if (items !== undefined) {
        this.setState({ items: items });
      }
    }
  }


  toggle = () => {

    this.setState({
      deleteModal: !this.state.deleteModal
    });
  }

  handleChange = (e) => {

    let name = e.target.name;
    let value = e.target.value;

    this.setState({ items: { ...this.state.items, [name]: value } });


  }


  handleChangeForFilter = (e) => {

    let name = e.target.name;
    let value = e.target.value;
    let model = this.state.model;

    let currentModel = _.findWhere(model,{field:name});
    let toBeFilered = {};
    

    if(currentModel.filter!=undefined){

      
      toBeFilered = _.findWhere(model,{field:currentModel.filter}); 

      let sourceList =  this.state['SOURCE_'+toBeFilered.editType];
      

      let filteredList =  _.filter(sourceList,function(item){


        return item[currentModel.filterId] == value;

      });


      this.setState({[toBeFilered.editType]:filteredList});




    }




    this.setState({ items: { ...this.state.items, [name]: value } });


  }

  handleEditorChange = (value, name) => {
    this.setState({ items: { ...this.state.items, [name]: value } });
  }

  changeRating(newRating, name) {
    this.setState({
      rating: newRating
    });
    this.setState({ items: { ...this.state.items, [name]: newRating } });
  }


  onFileUpload = (event, name) => {

    var files = event.target.files;





    this.setState({
      selectedFile: event.target.files[0],
      fileUrl: URL.createObjectURL(event.target.files[0])

    });


    let storage = context.props.firebaseStorage;

    var downloadURLs = [];

    _.each(files, function (file, i) {

      storage.child(file.name).put(file).then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (downloadURL) {
          context.setState({ msg: (i + 1) + " Image Has been uploaded!" })
          context.setState({ deleteModal: true });
          downloadURLs.push({ [name]: downloadURL });


          if (files.length == 1) {
            context.setState({ items: { ...context.state.items, [name]: downloadURL } })
          } else
            if (i == (files.length - 1)) {
              context.setState({ items: { ...context.state.items, [name]: downloadURLs } })
            }

        });
      });

    });








  }



  addNewItemToDb = (item) => {

    let firebaseDb = this.props.firebaseDb;
    let key = firebaseDb.push().key;
    item["key"] = key;
    firebaseDb.child(key).update(item);
    context.setState({ msg: "Item has been added" })
    context.setState({ deleteModal: true });


  };

  updateDbItem = (item, id) => {

    let firebaseDb = this.props.firebaseDb;


    if (this.props.dbType === "object") {
      var updatedItem = {};



      updatedItem = _.omit(item, function (value, key) {
        return (_.findWhere(context.state.model, { field: key }) == undefined);
      });





      firebaseDb.update(updatedItem);
    } else {
      firebaseDb.child(id).update(item);
    }

    context.setState({ msg: "Item has been updated" })
    context.setState({ deleteModal: true });


  };



  getListFromDb = (firebaseDb,i) => {

    firebaseDb.on('value', snap => {

      let dbList = [];
      let sourceList = [];
      console.log(snap);
      snap.forEach(shot => {


        sourceList.push({ ...shot.val(), key: shot.key });





      });


      context.setState({ ['LINKEDLIST'+i]: sourceList });
        context.setState({['SOURCE_LINKEDLIST'+i]: sourceList}); 


    });
  }


  render() {
    const { title, action, type, id } = this.props;
    const { model, items, fileUrl, linkedList } = this.state;
    return (<Card style={{ height: '100vh', overflowY: 'auto', paddingBottom: '20%' }} small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row >
            <Col>
              <Form>
                <Row form>


                  {model.map((item, idx) => (

                    item.type === "LISTINGS" ?

                      <Col md="12" className="form-group">
                        <Listings title={item.label} list={this.state.items[item.field] || []} />
                      </Col>

                      :
                      item.type === "EDITOR" ?

                        <Col md="12" className="form-group">
                          <label htmlFor={item.field}>{item.label}</label>
                          <ReactQuill

                            onChange={(v) => this.handleEditorChange(v, item.field)}
                            value={this.state.items[item.field] || ''}
                            className="add-new-post__editor mb-1" />
                        </Col>

                        :


                        item.type === "RATINGS" ?
                          <Col md="12" className="form-group">

                            <label htmlFor={item.field}>{item.label}</label>


                            <StarRatings
                              rating={this.state.items[item.field]}
                              starRatedColor="orange"
                              changeRating={(e) => this.changeRating(e, item.field)}
                              numberOfStars={5}
                              name='rating'
                            />

                          </Col>
                          :
                          item.type === "TEXTVIEW" ?


                            <Col md="12" className="form-group">
                              <label htmlFor={item.field}>{item.label}</label>
                              <FormTextarea id={item.field} onChange={this.handleChange} name={item.field}
                                value={this.state.items[item.field]}
                                rows="5" />
                            </Col>

                            :
                         
                            item.type === "IMAGE" || item.type==='FILE'?
                             <Col md="12" className="form-group">
                                <label htmlFor={item.field}>{item.label}</label>
                                <FileUpload fileType={item.type} imageSrc={fileUrl !== "" ? fileUrl : items[item.field]} itemField={item.field} onFileUpload={this.onFileUpload} /></Col> 
                              :
                              item.editType!=undefined && item.editType.includes("LINKEDLIST") ?
                                <Col md="12" className="form-group">
                                  <FormSelect onChange={this.handleChangeForFilter} name={item.field}
                                    value={this.state.items[item.field]}>
                                    <option selected="selected">Select {item.label}</option>
                                    {this.state[item.editType]!=undefined ? this.state[item.editType].map((item, idx) => (

                                      <option value={item.key}>{item.title}</option>

                                    )) :  <option disabled>Loading options or No options are avialable</option>}
                                  </FormSelect>
                                </Col>
                                :
                                item.editType === "SELECT" ?
                                  <FormSelect onChange={this.handleChange} name={item.field}
                                    value={this.state.items[item.field]}>
                                    <option selected="selected">Select {item.label}</option>
                                    {item.options.map((item, idx) => (

                                      <option value={item.value}>{item.name}</option>

                                    ))}

                                  </FormSelect> :


                                  <Col md={item.type == "FULL" ? "12" : "6"} className="form-group">
                                    <label htmlFor={item.field}>{item.label}</label>
                                    <FormInput
                                      type={item.editType}
                                      id={item.field} onChange={this.handleChange} name={item.field}
                                      value={this.state.items[item.field]}
                                    />
                                  </Col>


                  ))}



                </Row>



                {type === "UPDATE" ?
                  <Button className="mt-4" theme="accent" onClick={() => this.updateDbItem(items, id)}>{action}</Button>
                  :
                  <Button theme="accent" className="mt-4" onClick={() => this.addNewItemToDb(items)}>{action}</Button>
                }
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
      <MDBModal isOpen={this.state.deleteModal} toggle={this.toggle} size="sm">
        <MDBModalHeader toggle={this.toggle}>Information</MDBModalHeader>
        <MDBModalBody>
          {this.state.msg}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" size="sm" onClick={this.toggle}>Ok</MDBBtn>

        </MDBModalFooter>
      </MDBModal>

      <MDBModal isOpen={this.state.deleteModal} toggle={this.toggle} size="sm">
        <MDBModalHeader toggle={this.toggle}>Add List Item</MDBModalHeader>
        <MDBModalBody>
          {this.state.msg}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" size="sm" onClick={this.toggle}>Ok</MDBBtn>

        </MDBModalFooter>
      </MDBModal>

    </Card>);
  }

}


export default FormItem;
